module.exports = __webpack_public_path__ + "static/media/matrix-dark.b2e7871c.svg";